import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children", "overflowEllipsisWidth", "styleSheet"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { compose, defaultProps, setPropTypes, setDisplayName } from 'recompose';
import omitProps from '@hocs/omit-props';
import { ColorFunctions as Colors } from '@bubble-ui/particle-colors';
import wrapOverridableComponent from '@bubble-ui/hoc-wrap-overridable-component';
import { withDesignVersion } from '@bubble-ui/provider-design-version';
import { withDesignContext } from '@klarna/designtokens';
import defaultTextStyles from '@bubble-ui/particle-default-text-styles';
import Text from '@bubble-ui/primitive-text';
import withDeprecationWarning from '@bubble-ui/hoc-with-deprecation-warning';
var getDefaultStyleSheet = _ref => {
  var {
    centered,
    correctFootprint,
    disabled,
    darkGray,
    designContext,
    designVersion,
    error,
    inverseOnBackground,
    light,
    metadata,
    overflowEllipsisWidth,
    rightAligned,
    success,
    warning,
    white
  } = _ref;
  return {
    viewStyle: _objectSpread(_objectSpread({}, correctFootprint ? {
      marginBottom: -10,
      marginTop: -5
    } : {
      marginBottom: 0,
      marginTop: 0
    }), {}, {
      paddingBottom: 4,
      paddingTop: 1
    }),
    textStyle: _objectSpread(_objectSpread(_objectSpread({
      color: error ? Colors.__textError(designVersion).toString() : warning ? Colors.__textWarning(designVersion).toString() : success ? Colors.__textSuccess(designVersion).toString() : light ? Colors.__textNeutral(designVersion).toString() : disabled ? Colors.__textDisabled(designVersion).toString() : inverseOnBackground ? Colors.__textInverseOnBackground(designVersion).toString() : white ? Colors.__textInverse(designVersion).toString() : metadata ? Colors.__textNeutral(designVersion).toString() : darkGray ? Colors.__textNeutral(designVersion).toString() : Colors.__textDefault(designVersion).toString()
    }, designContext.get('text-style/text/super-paragraphs/tiny/regular').styles()), {}, {
      lineHeight: 20,
      textRendering: 'geometricPrecision',
      WebkitFontSmoothing: 'antialiased',
      textAlign: (() => {
        switch (true) {
          case centered:
            return 'center';
          case rightAligned:
            return 'right';
          default:
            return 'left';
        }
      })()
    }, overflowEllipsisWidth && {
      maxWidth: overflowEllipsisWidth,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }), {}, {
      wordBreak: 'break-word'
    })
  };
};
var ParagraphQuaternary = _ref2 => {
  var {
      children,
      overflowEllipsisWidth,
      styleSheet: {
        textStyle,
        viewStyle
      }
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(Text, _extends({
    numberOfLines: overflowEllipsisWidth ? 1 : 0,
    tag: "paragraph",
    style: _objectSpread(_objectSpread({}, textStyle), viewStyle)
  }, props), children);
};
export default compose(setDisplayName('ParagraphQuaternary'), setPropTypes({
  correctFootprint: PropTypes.bool,
  darkGray: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  inverseOnBackground: PropTypes.bool,
  success: PropTypes.bool,
  rightAligned: PropTypes.bool,
  centered: PropTypes.bool,
  light: PropTypes.bool,
  metadata: PropTypes.bool,
  white: PropTypes.bool,
  children: PropTypes.node,
  warning: PropTypes.bool
}), defaultProps({
  correctFootprint: false
}), withDesignVersion, withDesignContext(defaultTextStyles),
// ⚠️ THIS COMPONENT SUPPORTS STYLE SHEET OVERRIDES ⚠️
// Keep passing all props to the style sheet, even if we don't use them ourselves
wrapOverridableComponent('ParagraphQuaternary', getDefaultStyleSheet), omitProps('centered', 'brandColorOne', 'brandColorTwo', 'brandColorThree', 'brandColorFour', 'brandColorFive', 'brandColorSix', 'correctFootprint', 'darkGray', 'designContext', 'designVersion', 'disabled', 'error', 'inverseOnBackground', 'light', 'metadata', 'rightAligned', 'success', 'warning', 'white'), withDeprecationWarning({
  name: 'ParagraphQuaternary',
  removalDate: 'v6.0.0',
  useInstead: 'Typography'
}))(ParagraphQuaternary);
//# sourceMappingURL=index.js.map